import React, { Suspense, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";

// components
// import Home from "./pages/Home";
import Auth from "./modules/users/Auth";


// contexts
import AuthContext from "./contexts/authContext";
import { UserData } from "./contexts/UserInfoContext";
import CartContext from "./contexts/CartContext";

// api
import config from "./modules/users/config.json";
import { getData } from "./services/API";

// local storage functions
import {
  removeItemStorage,
  setItemStorage,
} from "./Localstorage/useLocalStorage";
import { useContext } from "react";
import AdminRoutes from "./Routes/AdminRoutes";
import AccessContext from "./contexts/AccessContext";
import CompareContext from "./contexts/CompareContext";
import { lazy } from "react";
import FavouriteContext from "./contexts/FavouriteContext";
import PageLoading from "./components/shared/PageLoading";
import SiteInfoContext from "./contexts/SiteInfoContext";

const Panel = lazy(() => import("./AdminPanel/Panel"));

const App = () => {
  const {
    api_url: { g_user_profile },
  } = config;

  const { user, setUser, userLoaded } = useContext(UserData);
  const navigate = useNavigate();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [token, setToken] = useState(null);
  const [userInfo, setUserInfo] = useState({});
  const [formFields, setFormFields] = useState([]);

  // get user data
  const getUserData = () => {
    getData(g_user_profile.url, {}, true)
      .then((res) => {
        setUser({ ...res.data.data.user });
        navigate("/user");
      })
      .catch((err) => {});
  };

  const userPhoneNumber = (res, userPhone) => {
    setUserInfo({ phone_number: userPhone });
    setFormFields(res.data?.reg_form_fields);
  };

  const userLogin = (res) => {
    setToken(res.token);
    setItemStorage("token", res.token);
    setIsLoggedIn(true);
  };

  const userVerify = (res, code) => {
    if (res.status === "success") {
      setUserInfo({ ...userInfo, completeProfile: true, vcode: code });
    }
  };

  const userCompleteProfile = (res, userData) => {
    setUserInfo({ ...userInfo, ...userData });
    setToken(res.token);
    setItemStorage("token", res.token);
    setIsLoggedIn(true);
  };

  const userPasswordRecovery = (userData) => {
    setToken(userData.token);
    setItemStorage("token", userData.token);
    setIsLoggedIn(true);
  };

  const userLogout = () => {
    setIsLoggedIn(false);
    setToken(null);
    removeItemStorage("token");
    setUserInfo({ ...userInfo, completeProfile: false });
  };

  return (
    <div className="App">
      <AuthContext.Provider
        value={{
          isLoggedIn,
          userInfo,
          token,
          formFields,
          userPhoneNumber,
          userLogin,
          userVerify,
          userCompleteProfile,
          userLogout,
          userPasswordRecovery,
        }}
      >
        <CartContext>
          <AccessContext>
            <CompareContext>
              <FavouriteContext>
                <SiteInfoContext>
                  <Routes>
                    <Route element={<AdminRoutes />}>
                      <Route
                        path="/*"
                        element={
                          <Suspense fallback={<PageLoading />}>
                            <Panel />
                          </Suspense>
                        }
                      />
                    </Route>
                    <Route path="/auth" element={<Auth />} />
                  </Routes>
                </SiteInfoContext>
              </FavouriteContext>
            </CompareContext>
          </AccessContext>
        </CartContext>
      </AuthContext.Provider>
    </div>
  );
};

export default App;
